var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServices1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9ecef"
    },
    d: "M119.79 95.2H377.2v25.13H119.79zM73.34 95.2h36.75v25.13H73.34zM386.91 95.2h36.75v25.13h-36.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.79 230a24.18 24.18 0 0 1-46.79 0l-.3-1.19h47.43z",
    style: {
      fill: "#ffc600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9ecef"
    },
    d: "m269.72 275.22 8.77 8.77v16.36h-59.98v-16.36l8.77-8.77h42.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.34 228.76 208 230a24.18 24.18 0 0 1-46.82 0l-.31-1.19z",
    style: {
      fill: "#ffc600"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M428.51 85.49h-360a4.86 4.86 0 0 0-4.85 4.86v302a4.86 4.86 0 0 0 4.85 4.86h360a4.87 4.87 0 0 0 4.86-4.86v-302a4.87 4.87 0 0 0-4.86-4.86zM119.79 95.2H377.2v25.14H119.79zm-46.45 0h36.74v25.14H73.34zm350.32 292.26H73.34V130.05h350.32zm0-267.12h-36.75V95.2h36.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.62 257.8a34 34 0 0 0 33.89-33.89 4.88 4.88 0 0 0-.61-2.36l-.49-.87-24.54-44.18h50.77v89h-18.37a4.83 4.83 0 0 0-3.43 1.42l-11.62 11.62a4.83 4.83 0 0 0-1.42 3.46v18.37h-11.61v9.71h102.62v-9.71h-11.62V282a4.78 4.78 0 0 0-1.42-3.43l-11.61-11.62a4.86 4.86 0 0 0-3.43-1.42h-18.38v-89h50.77l-24.54 44.18-.48.87a4.89 4.89 0 0 0-.62 2.36 33.89 33.89 0 1 0 67.78 0 4.88 4.88 0 0 0-.61-2.36l-.48-.87-24.54-44.21h8.21v-9.71h-75.49v-11.61h-9.71v11.61h-75.49v9.71h8.22l-24.54 44.18-.49.87a4.88 4.88 0 0 0-.61 2.36 34 34 0 0 0 33.89 33.89zM335.79 230a24.18 24.18 0 0 1-46.79 0l-.3-1.19h47.43zm-2.63-10.9h-41.57l20.78-37.41zm-63.44 56.17 8.76 8.77v16.36h-60V284l8.77-8.77zm-85.1-93.58 20.78 37.41h-41.56zm23.72 47.12L208 230a24.18 24.18 0 0 1-46.82 0l-.31-1.19zM313.33 300.35h9.71v9.71h-9.71zM121.7 323.58h9.71v9.71h-9.71zM144.92 323.58h96.82v9.71h-96.82zM121.7 346.81h120.04v9.71H121.7zM255.26 323.58h9.71v9.71h-9.71zM278.48 323.58h96.82v9.71h-96.82zM255.26 346.81H375.3v9.71H255.26z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices1);
export default __webpack_public_path__ + "static/media/services1.27bdf9a8b7ff041d4494c82d4d8d3f89.svg";
export { ForwardRef as ReactComponent };